import { render, staticRenderFns } from "./JLayout.vue?vue&type=template&id=03236df2&scoped=true&"
import script from "./JLayout.vue?vue&type=script&lang=js&"
export * from "./JLayout.vue?vue&type=script&lang=js&"
import style0 from "./JLayout.vue?vue&type=style&index=0&id=03236df2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03236df2",
  null
  
)

export default component.exports